import React from 'react'
import { Grid, Typography, Link, makeStyles, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import SpecificationSelect from '../Specifications/SpecificationSelect'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(8),
  },
  specificationItem: {
    paddingTop: theme.spacing(4),
  },
  recommendation: {
    padding: theme.spacing(1, 0, 2),
  },
  infoMessage: {
    padding: theme.spacing(2, 0),
  },
}))

const SangerVector = () => {
  const classes = useStyles()

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h3">
          <FormattedMessage
            id="CONF_DNA_VECTOR_SPECIFICATION_sangercrispr"
            defaultMessage="Sanger Vector"
          />
        </Typography>
      </Grid>

      <Grid item xs={12} className={classes.recommendation}>
        <FormattedMessage
          id="CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna"
          defaultMessage="View vector maps and features at"
        />
        <Link
          href="/technical-documents/technical-article/genomics/advanced-gene-editing/crispr-clone-control-and-cas9-essentials"
          underline="hover"
          target="_blank"
        >
          <span>
            <FormattedMessage
              id="CONF_DNA_LINK_SPECIFICATION_crispgrna"
              defaultMessage=" CRISPR Essentials"
            />
          </span>
        </Link>
      </Grid>

      <SpecificationSelect
        list={[]}
        fieldName="vector"
        specificationLabel={
          <FormattedMessage
            id="CONF_DNA_VECTOR_SPECIFICATION_sangercrispr"
            defaultMessage="Sanger Vector"
          />
        }
        specificationValue="LV04"
        handleChange={() => null}
        fitContent
        defaultValue={{
          key: 'LV04',
          value: '(LV04) U6-gRNA:hPGK-puro-2A-tBFP',
        }}
      />
    </Grid>
  )
}

export default SangerVector
